import { AbstractControl, AsyncValidatorFn, ValidationErrors, ValidatorFn } from "@angular/forms";
import { TenantUserService } from "blg-akaun-ts-lib";

export function emailValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        let valid = re.test(String(control.value).toLowerCase());
        return valid ? null : {invalidEmail: {value: control.value}}
    };
}

export function subjectWithEmailExistsValidator(tenantUserService, apiVisa): AsyncValidatorFn {
    return async (control: AbstractControl): Promise<ValidationErrors | null> => {
        let email = control.value.replace('@', '%40')
        let dto = {};
        return await tenantUserService.addUser(email, dto, apiVisa).toPromise().then((resp) => {  // Checks if user exists. Idk why it uses a POST request
            if (resp.code = 'OK_RESPONSE') {
                return null
            } else {
                return {subjectWithEmailNonexistant: {value: control.value}}
            }
        }, error => {
            if (error.error.code.toString().includes('already exists')) {
                return null
            } else {
                return {subjectWithEmailNonexistant: {value: control.value}}
            }
        });
    }
}